import { useCustomerStore } from '@stores/me/customer'

import { defineNuxtRouteMiddleware, useRouter } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const customerStore = useCustomerStore()

  if (customerStore.isTypePaid) {
    const redirectUrl = to.path.replace('/pad', '/pricing')
    const router = useRouter()

    await router.push(redirectUrl)
  }
})
